<template>
    <div class="flex items-center justify-between gap-4 bg-gray-200 p-6 md:rounded-b md:p-8">
        <div class="flex items-center gap-4">
            <span class="hidden md:block">{{ $t('shopPage.product.amount') }}: </span>
            <div class="max-w-56 grow-0">
                <FormKit
                    v-model="productForm().currentProductWithSelectedExtras.quantity"
                    type="stepNumber"
                    :min="1"
                    :max="getCurrentProductMax"
                    name="quantity" />
            </div>
        </div>
        <div class="flex items-center gap-4">
            <span v-if="price" class="text-xl font-bold md:text-3xl">+ {{ predictPriceOfProduct(props, productForm().currentProductWithSelectedExtras) }}</span>
            <FormKit
                type="submit"
                class="shrink-0 grow-0"
                :classes="{
                    input: {
                        'bg-gray-400': !valid,
                        'hover:bg-gray-400': !valid,
                        'cursor-not-allowed': !valid
                    }
                }"
            >
                {{ productKeyToReplace ? $t('shopPage.product.modifyInCart') : $t('shopPage.product.addToCart') }}
            </FormKit>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
    import { getProductMaximumOrderQuantity } from '~/composables/productLimitations'
    import { cart } from '~/store/cart'
    import { productForm } from '~/store/productForm'
    import { predictPriceOfProduct } from '~/utils/product-utils'
    export type ModalProductProps = ProductOrderBuddy & {
        productKeyToReplace?: string | number
        valid: boolean
    }
    const props = defineProps<ModalProductProps>()
    const getCurrentProductMax = computed(() => {
        return getProductMaximumOrderQuantity(props, props.productKeyToReplace ? cart().cart.products[props.productKeyToReplace].quantity : 0)
    })
</script>
